/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

const config = {};

config.cookie_first = null;
config.google_tag_manager = 'GTM-K2Q2F58';
config.google_tag_manager_auth = 'gNVFNcq8a8VutZQcSQZ8jg';
config.google_tag_manager_preview = 'env-2';
config.google_tag_manager_cookies_win = 'x';
config.adobe_analytics = false;
config.hotjar = null;

export default config;
